import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faQrcode, faCheck, faArrowLeft, faCalendar, faClock, faLocationDot, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Toast, ToastHeader, ToastBody } from 'reactstrap';
import moment from 'moment';
import { NumericFormat, PatternFormat } from 'react-number-format';
import useApiFetch from '../../ApiFetch';
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';
import MyPass from './MyPass';
import EventGuests from './EventGuests';

export default function Event(props) {
    const { event, retrievePass, viewPass } = props;
    const { eventCode, registrationCode, passCode } = useParams();
    const params = useParams();
    const navigate = useNavigate();
    const apiFetch = useApiFetch();
    const isAuthenticated = useIsAuthenticated();
    const authUser = useAuthUser();

    const myPassRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [eventData, setEventData] = useState([]);
    const [modal, setModal] = useState(false);

    const [modalCode, setModalCode] = useState(false);
    const [regCode, setRegCode] = useState('');
    const [invalidCode, setInvalidCode] = useState(null);

    const [validated, setValidated] = useState(false);
    const [registration, setRegistration] = useState({ firstName: '', lastName: '', email: '', company: '', phone: '', optin: true });
    const [registering, setRegistering] = useState(false);
    const [registeredData, setRegisteredData] = useState(null);
    const [isRegistered, setIsRegistered] = useState(false);

    const [modalRetrievePass, setModalRetrievePass] = useState(false);
    const [retrievePassEmail, setRetrievePassEmail] = useState('');
    const [retrievingPass, setRetrievingPass] = useState(false);
    const [retrieved, setRetrieved] = useState(false);

    const modalToggle = () => {
        setModal(!modal)
        setRegisteredData(null);
        setValidated(false);
        setRegistering(false);
        //    if (!isAuthenticated())
        //        setRegistration({ firstName: '', lastName: '', email: '', company: '', phone: '' });
    };
    const modalCodeToggle = () => {
        setModalCode(!modalCode)
        setRegisteredData(null);
        setValidated(false);
        setRegistering(false);
        //    if (!isAuthenticated())
        //        setRegistration({ firstName: '', lastName: '', email: '', company: '', phone: '' });
    };
    const modalRetrievePassToggle = () => {
        setModalRetrievePass(!modalRetrievePass);
        setRetrievePassEmail('');
        setValidated(false);
        setRetrievingPass(false);
        setRetrieved(false);
    };
    useEffect(() => {
        setLoading(true);
        setRegistering(false);

        getData();

    }, []);
    const getData = async () => {
        await apiFetch.get('/api/event/' + encodeURIComponent(eventCode))
            .then(resp => {
                setEventData(resp.data);
                if (isAuthenticated() && resp.data) {
                    apiFetch.get('/api/event/' + encodeURIComponent(eventCode) + '/isregistered')
                        .then(resp => {
                            setIsRegistered(resp.data);
                        });
                }
                setLoading(false);
            });
    };
    const getEventDates = () => {
        if (eventData) {
            if (eventData.endDate) {
                //if we have an end date, check to see if the start and end dates are the same, if they are, show just one date
                if (eventData.endDate === eventData.startDate) {
                    return moment(eventData.startDate).format('MMMM D');
                }
                else {
                    //if the month is the same, show Month Start-End, otherwise, show Month Start - Month End
                    if (moment(eventData.startDate).month() === moment(eventData.endDate).month()) {
                        return moment(eventData.startDate).format('MMMM') + ' ' + moment(eventData.startDate).format('D') + '-' + moment(eventData.endDate).format('D');
                    }
                    else {
                        return moment(eventData.startDate).format('MMMM D') + '-' + moment(eventData.endDate).format('MMMM D');
                    }
                }
            }
            else {
                return moment(eventData.startDate).format('MMMM D');
            }
        }

    };
    const getEventTimes = () => {
        if (eventData && eventData.startTime) {
            if (eventData.endTime) {
                //if we have an end date, check to see if the start and end dates are the same, if they are, show just one date
                if (eventData.endTime === eventData.startTime) {
                    return moment(eventData.startTime, 'HH:mm:ss').format('h:mm A');
                }
                else {
                    return moment(eventData.startTime, 'HH:mm:ss').format('h:mm A') + '-' + moment(eventData.endTime, 'HH:mm:ss').format('h:mm A');
                }
            }
            else {
                return moment(eventData.startTime, 'HH:mm:ss').format('h:mm A');
            }
        }
        else {
            return null;
        }

    };
    const handleRegister = async (event) => {
        const form = event.currentTarget;
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            event.preventDefault();
            event.stopPropagation();

            setRegistering(true);
            let regObj = registration;
            if (isAuthenticated() && authUser && authUser.user) {
                regObj.userId = authUser.user.id;
            }
            await apiFetch.post('/api/event/' + encodeURIComponent(eventCode) + '/register', regObj)
                .then(resp => {
                    setRegisteredData(resp.data);
                    setRegistering(false);
                    getData();
                });
        }
        setValidated(true);
    };
    const handlePatternFormatChange = (values, sourceInfo) => {
        if (sourceInfo.source !== 'event') {
            return;
        }
        setRegistration({ ...registration, [sourceInfo.event.target.name]: values.value })
    };

    const handleRegisterButton = () => {
        if (eventData.requiresRegistrationCode) {
            modalCodeToggle();
        } else {
            handleContinueRegister();
        }
    };
    const handleCodeContinue = async (event) => {
        setInvalidCode(null);
        await apiFetch.post('/api/event/' + encodeURIComponent(eventCode) + '/registrationcode/', regCode, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then(resp => {
                if (resp.data) {
                    handleContinueRegister();
                    setRegCode('');
                    setInvalidCode(null);
                }
                else
                    setInvalidCode(regCode);
            })
            .catch(async (error) => {
            });
    };
    const handleContinueRegister = () => {
        if (modalCode) modalCodeToggle();
        setRegistration({ firstName: '', lastName: '', email: '', company: '', phone: '', optin: true });
        if (isAuthenticated()) {
            setRegistration({
                firstName: authUser.user.firstName,
                lastName: authUser.user.lastName,
                email: authUser.user.email,
                company: authUser.user.company,
                phone: authUser.user.phone,
                optin: true
            })
        }
        modalToggle();
    };
    
    const handleRetrievePass = async (event) => {
        const form = event.currentTarget;
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            event.preventDefault();
            event.stopPropagation();

            setRetrievingPass(true);
            setRetrieved(false);

            //First look for the registration that matches this email
            //If you find a registration, then get all the passes for that registration, including guest passes
            //if you don't find a registration, then look for a pass with that email associated with it
            //if you don't find a pass with that email associated, then look for a Guest with that email and retrieve/generate a pass

            await apiFetch.post('/api/event/' + encodeURIComponent(eventCode) + '/retrieveregistration/', retrievePassEmail, {
                headers: { 'Content-Type': 'application/json' }
            })
                .then(resp => {
                    setRetrieved(true);
                    setRetrievingPass(false);
                })
                .catch(async (error) => {
                    //If not found, check to see if we can find as a guest pass
                    await apiFetch.post('/api/event/' + encodeURIComponent(eventCode) + '/retrievepass/', retrievePassEmail, {
                        headers: { 'Content-Type': 'application/json' }
                    })
                        .then(resp => {
                            setRetrieved(true);
                       })
                        .catch(error => {
                            setRetrieved(true);
                        });



                    setRetrievingPass(false);
                    setRetrieved(true);
                 });



        }
        setValidated(true);
    };
    const openMyPass = () => {
        if (myPassRef.current) {
            myPassRef.current.handleMyPass();
        }

    };

    const handleRegisterLink = () => {
        if (eventData.requiresRegistrationCode) {
            modalCodeToggle();
        } else {
            handleContinueRegister();
        }
        setRetrievePassEmail('');
        setRetrievingPass(false);
        setRetrieved(false);
        modalRetrievePassToggle();
    };
    const eventGuestsUpdated = (guests) => {
        setRegistration({ ...registration, eventGuests: guests });
    }

    return (
        <>
            <div className="container-xl col-xxl-10 px-4 pt-1 pb-5">
                <div className="d-flex text-end pb-3">
                    <ol className="list-group breadcrumb p-2 me-auto">
                        <li className="breadcrumb-item">
                            <Link to="/events" className="link-body-emphasis fw-semibold text-decoration-none">
                                <FontAwesomeIcon icon={faArrowLeft} className="pe-2" />
                                <span className="">Back</span>
                            </Link>
                        </li>
                    </ol>
                </div>
                <div className="card mb-5">
                    <div className="row flex-lg-row align-items-center g-0 py-0 shadow-lg">
                        <div className="col-12 col-sm-12 col-lg-6 text-center">
                            <img style={{ maxHeight: '400px' }} src={eventData && eventData.imageUrl ? eventData.imageUrl : './assets/images/hyetech_logo2_4color.png'} className="img-fluid rounded-start" alt="..." />
                        </div>
                        <div className="col-12 col-sm-12 col-lg-6 ps-4">
                            <div className="card-body">
                                <h1 className="display-5 fw-bold text-body-emphasis lh-1 mb-3">{eventData.title}</h1>
                                <p className="lead pt-3">
                                    <FontAwesomeIcon icon={faCalendar} /> {getEventDates()} &nbsp;
                                    {getEventTimes() ? <><FontAwesomeIcon icon={faClock} /> {getEventTimes()}</> : null}
                                    {eventData.venue || eventData.room
                                        ?
                                        <>
                                            <br />
                                            <FontAwesomeIcon icon={faLocationDot} />&nbsp;
                                            {eventData.venue ?? eventData.room}
                                        </>
                                        :
                                        null}
                                </p>
                                <div className="gap-2 d-sm-flex justify-content-start align-items-center">
                                    {(isAuthenticated() && isRegistered) || (retrievePass && (registrationCode || passCode)) ?
                                        <>
                                            <MyPass ref={myPassRef} className="px-4 btn-lg" event={eventData} registrationCode={registrationCode} passCode={passCode} retrievePass={retrievePass} viewPass={viewPass} />
                                            <button type="button" className="btn btn-outline-primary disabled btn-lg px-4 me-md-2" onClick={handleRegisterButton}>
                                                Registered
                                                <FontAwesomeIcon icon={faCheck} className="ps-2 text-success" />
                                            </button>
                                        </>
                                        :
                                        <>
                                            <div className="">
                                                <button type="button" className="col-12 btn btn-primary btn-lg px-4 me-md-2" onClick={handleRegisterButton}>Register</button>
                                            </div>
                                            <div className="align-self-center text-center">
                                                <p className="mb-0" style={{ lineHeight: '16px' }}>
                                                    <small>
                                                        <Link onClick={modalRetrievePassToggle} className="text-body-secondary col-12 lh-1 link-body-emphasis text-decoration-none text-center">
                                                            Already Registered?
                                                            <br />
                                                            Retrieve Your Pass
                                                        </Link>
                                                    </small>
                                                </p>
                                            </div>
                                        </>
                                    }
                                    {/*<button type="button" className="btn btn-outline-secondary btn-lg px-4">Default</button>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*<div className="row flex-lg-row align-items-center g-5 py-5">*/}
                {/*    <div className="col-12 col-sm-12 col-lg-6">*/}
                {/*        <img src="https://www.shutterstock.com/shutterstock/photos/2062252346/display_1500/stock-vector-abstract-modern-business-conference-design-template-with-lines-minimal-flyer-layout-eps-vector-2062252346.jpg" className="d-block mx-lg-auto img-fluid" alt="" loading="lazy" />*/}
                {/*    </div>*/}
                {/*    <div className="col-12 col-sm-12 col-lg-6">*/}
                {/*        <h1 className="display-5 fw-bold text-body-emphasis lh-1 mb-3">{eventData.title}</h1>*/}
                {/*        <p className="lead pt-3">*/}
                {/*            <FontAwesomeIcon icon={faCalendar} /> {getEventDates()} &nbsp;*/}
                {/*            {getEventTimes() ? <><FontAwesomeIcon icon={faClock} /> {getEventTimes()}</> : null}*/}
                {/*            {eventData.venue || eventData.room*/}
                {/*                ?*/}
                {/*                <>*/}
                {/*                    <br />*/}
                {/*                    <FontAwesomeIcon icon={faLocationDot} />&nbsp;*/}
                {/*                    {eventData.venue ?? eventData.room}*/}
                {/*                </>*/}
                {/*                :*/}
                {/*                null}*/}
                {/*        </p>*/}
                {/*        <div className="d-grid gap-2 d-md-flex justify-content-md-start">*/}
                {/*            <button type="button" className="btn btn-primary btn-lg px-4 me-md-2" onClick={modalToggle}>Register</button>*/}
                {/*            */}{/*<button type="button" className="btn btn-outline-secondary btn-lg px-4">Default</button>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="row mt-5">
                    <div className="col-12 col-md-8 col-lg-8 pb-5">
                        <h3 className="text-muted text-secondary">Description</h3>
                        <div className="lead" style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: eventData.description }} />
                    </div>
                    <div className="col-12 col-md-4 col-lg-4">
                        <h4 className="text-muted text-secondary">Location</h4>
                        {eventData && (eventData.venue || eventData.room || eventData.address || eventData.city || eventData.state || eventData.zip)
                            ?
                            <p className="lead">
                                {eventData.venue ? <>{eventData.venue}<br /></> : null}
                                {eventData.room ? <>{eventData.room}<br /></> : null}
                                {eventData.address ? <>{eventData.address}<br /></> : null}
                                {eventData.city ? <>{eventData.city}</> : null}{eventData.city && eventData.state ? ', ' : null} {eventData.state ? <>{eventData.state}</> : null} {eventData.zip ? <>{eventData.zip}</> : null}{eventData.city || eventData.state || eventData.zip ? <br /> : null}
                            </p>
                            :
                            'TBD'
                        }
                    </div>
                </div>
            </div>
            <Modal isOpen={modalCode} toggle={modalCodeToggle} size="md" fade={true}>
                <ModalHeader toggle={modalCodeToggle}>
                    <FontAwesomeIcon icon={faLock} className="pe-2" />Code
                </ModalHeader>
                <ModalBody className="">
                    <div className="col">
                        <h4 className="mb-3">Registration Code</h4>
                        <h5 className="text-secondary-emphasis">This event requires a registration code.  Please enter the code below to register.</h5>
                        <div className="row g-3">
                            <div className="col-12 text-center d-flex justify-content-center pt-3">
                                <input type="text" name="regCode" value={regCode} onChange={(e) => setRegCode(e.target.value)} maxLength="8" className="form-control form-control-lg text-uppercase text-center" style={{
                                    fontSize: '2em', width: '12ch',
                                    fontFamily: 'monospace'
                                }} required />
                            </div>
                            <div className="col-12 text-center">
                                <button className="btn btn-primary btn-lg" type="submit" disabled={registering} onClick={handleCodeContinue} >
                                    {registering ? <FontAwesomeIcon icon={faSpinner} className='me-3' spin /> : null}
                                    Continue
                                </button>
                            </div>
                            {invalidCode &&
                                <div className="col-12 text-center text-danger mt-0 pt-1">
                                    Invalid Code
                                </div>
                            }
                        </div>
                        <div className="row justify-content-center pt-3">
                            <div className="col-12 text-center">
                                Don't have a code?<br />
                                Reach out to any HyeTech team member <br />
                                or email us at <a href="mailto:events@hyetechnetworks.com" clasName="link-body-emphasis fw-semibold text-decoration-none">events@hyetechnetworks.com</a>
                            </div>
                        </div>
                    </div>

                </ModalBody>
            </Modal>
            <Modal isOpen={modal} toggle={modalToggle} size="md" fade={true}>
                <ModalHeader toggle={modalToggle}>
                    <FontAwesomeIcon icon={faCalendar} className="pe-2" />Event Registration
                </ModalHeader>
                <ModalBody className="">
                    {registeredData ?
                        <div className="py-5 text-center">
                            <img className="d-block mx-auto mb-4" src="./assets/images/hyetech_logo2_4color.png" alt="" height="200" />
                            <h2 className="text-success">Success!</h2>
                            <p className="lead">
                                You have successfully registered for this event.
                            </p>
                        </div>
                        :
                        <div className="col">
                            <h4 className="mb-3">Your Info</h4>
                            <form noValidate className={`needs-validation ${validated ? 'was-validated' : ''}`} onSubmit={handleRegister}>
                                <div className="row g-3">
                                    <div className="col-sm-6">
                                        <label htmlFor="firstName" className="form-label">First Name</label>
                                        <input type="text" name="firstName" value={registration.firstName} onChange={(e) => setRegistration({ ...registration, [e.target.name]: e.target.value })} className="form-control" id="firstName" required />
                                        <div className="invalid-feedback">
                                            Valid first name is required.
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <label htmlFor="lastName" className="form-label">Last Name</label>
                                        <input type="text" name="lastName" value={registration.lastName} onChange={(e) => setRegistration({ ...registration, [e.target.name]: e.target.value })} className="form-control" id="lastName" placeholder="" required />
                                        <div className="invalid-feedback">
                                            Valid last name is required.
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="Company" className="form-label">Company</label>
                                        <input type="text" name="company" value={registration.company} onChange={(e) => setRegistration({ ...registration, [e.target.name]: e.target.value })} className="form-control" id="Company" placeholder="" required />
                                        <div className="invalid-feedback">
                                            Your company is required.
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input type="email" name="email" value={registration.email} onChange={(e) => setRegistration({ ...registration, [e.target.name]: e.target.value })} className="form-control" id="email" placeholder="you@company.com" required />
                                        <div className="invalid-feedback">
                                            Please enter a valid email address.
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="phone" className="form-label">Phone</label>
                                        <PatternFormat name="phone" onValueChange={handlePatternFormatChange} className="form-control" id="phone" format="+1 (###) ###-####" value={registration.phone} valueIsNumericString={true} allowEmptyFormatting mask="_" />
                                        <div className="invalid-feedback">
                                            Please enter a valid phone number.
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-4" />
                                {eventData?.supportsGuests &&
                                    <div className="text-center">
                                        This event allows registrants to bring guests.<br />Would you like to bring guests?
                                        <EventGuests event={eventData} registrationId={registeredData?.id} updatedGuests={eventGuestsUpdated} />
                                        <hr className="my-4" />
                                    </div>
                                }

                                <button className="w-100 btn btn-primary btn-lg" type="submit" disabled={registering}>
                                    {registering ? <FontAwesomeIcon icon={faSpinner} className='me-3' spin /> : null}
                                    Register
                                </button>
                                <small>
                                    <div className="row g-0 justify-content-center ">
                                        <div className="col-auto mb-0 mt-1 pb-0">
                                            <div className="form-check mb-0">
                                                <small>
                                                    <input className="form-check-input mt-1" style={{  }} type="checkbox" id="chkOptin" name="optin" checked={registration.optin ?? true} onChange={(e) => setRegistration({ ...registration, [e.target.name]: e.target.checked })} required={false} />
                                                    <label className="form-check-label" htmlFor="chkOptin" style={{ color: 'inherit' }}>
                                                        Yes, I'd like to receive newsletters and invitations to future events.
                                                    </label>
                                                </small>
                                            </div>
                                        </div>
                                        <div className="form-text col-auto mt-0 pt-0">
                                            <small>You can manage your communication preferences in your profile at any time.</small>
                                        </div>
                                    </div>
                                </small>
                            </form>
                        </div>
                    }

                </ModalBody>
            </Modal>
            <Modal isOpen={modalRetrievePass} toggle={modalRetrievePassToggle} size="sm" fade={true} className="modal-fullscreen-sm-down">
                <ModalHeader toggle={modalRetrievePassToggle}>
                    <FontAwesomeIcon icon={faQrcode} className="pe-2" />Retrieve Pass
                </ModalHeader>
                <ModalBody className="">
                    <div className="col">
                        {retrieved ?
                            <div className="text-center mb-3">
                                <span className="">
                                    If a registration is found, you will receive an email with your pass.<br /><br />No email?<br /> Please <Link className="link-body-emphasis fw-semibold text-decoration-none" onClick={handleRegisterLink}>Register</Link> for the event.
                                </span>
                            </div>
                            :
                            <>
                                <h4 className="">Your Email</h4>
                                <span className="text-secondary">Please provide the email that was used to register for the event. Your pass will be emailed to the email address used in the registration.</span>
                                <form noValidate className={`mt-3 needs-validation ${validated ? 'was-validated' : ''}`} onSubmit={handleRetrievePass}>
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <input type="email" name="email" value={retrievePassEmail} onChange={(e) => setRetrievePassEmail(e.target.value)} className="form-control" id="email" placeholder="you@company.com" required />
                                            <div className="invalid-feedback">
                                                Please enter a valid email address.
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="mt-4" />
                                    <button className="w-100 btn btn-primary btn-lg" type="submit" disabled={retrievingPass}>
                                        <FontAwesomeIcon icon={retrievingPass ? faSpinner : faQrcode} spin={retrievingPass} className="me-2" />Retrieve Pass
                                    </button>
                                </form>
                            </>
                        }
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};
